    <div class="map-container">
      <div>
        <div>
          <!-- TODO: filters catégories et stars-->
        </div>
      </div>
      <div id="map"></div>
      @if (loading) {
        <div class="loading">Chargement de la carte...</div>
      }
      @if (error) {
        <div class="error">{{ error }}</div>
      }
    </div>